import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { FiXCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  cancelProject,
  fetchProject,
} from "../../../../redux/slices/projectSlice";

export default function CancelProject({ id, name }) {
  const [showModal, setShowModal] = useState(false);
  const statusCancel = useSelector((state) => state.projects?.statusCancel);
  const dispatch = useDispatch();

  const handleCancel = async () => {
    try {
      const res = await dispatch(cancelProject(id)).unwrap();
      await dispatch(fetchProject());
      toast.success(res.message || "Project cancelled successfully");
      setShowModal(false);
    } catch (error) {
      toast.error("Failed to cancel project");
      console.error(error);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="hover:shadow-lg"
      >
        <FiXCircle className="text-xl text-gray-600 hover:text-red-600" />
      </button>

      {showModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-25">
            <div className="relative w-full max-w-md mx-auto my-6">
              <div className="relative flex flex-col rounded-lg bg-white p-6 shadow-lg outline-none">
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-900"
                >
                  <FaTimes className="text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>

                <div className="space-y-4">
                  <h1 className="text-2xl text-center font-semibold text-gray-800">
                    Cancel Project
                  </h1>
                  <p className="text-center text-sm sm:text-base text-gray-700 leading-relaxed">
                    Are you sure you want to cancel the project{" "}
                    <strong className="text-red-600 font-semibold">
                      "{name}"
                    </strong>
                    ?
                    <br />
                    <span className="text-gray-500">
                      This action is irreversible and will permanently remove
                      this project.
                    </span>
                  </p>
                </div>

                <div className="mt-6 flex justify-center gap-4">
                  <button
                    onClick={() => setShowModal(false)}
                    className="rounded-lg bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-700"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleCancel}
                    disabled={statusCancel === "loading"}
                    className="flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-70"
                  >
                    {statusCancel === "loading" ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Canceling...
                      </>
                    ) : (
                      "Cancel Project"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
